import AllFilters from 'filters/all-filters';

window.searchPage = function () {
    let instantSearch;
    const instantSearchExamples = [
        "Did you know it can take up to 1,000 years for a single centimetre of topsoil to form? Soils store more carbon than the atmosphere and all of the world's plants and forests combined. They store 1.5 Olympic swimming pools of water per hectare and enable 95% of global food production. Yet we have limited understanding of how this complex ecosystem functions - for example, only about 1% of the microorganisms found in soil have been identified so far, even though they play a major role in carbon sequestration and food security.",
        "Batteries allow us to swap out fossil hydrocarbons for a different set of high density fuels: metals. Metals are cheap, dense, transportable, and most importantly, they don't vaporise into greenhouse gases upon combustion. But from a first principles perspective, we're still doing a lousy job of leveraging metallic fuels. Lithium as a material has roughly the same specific energy as jet fuel. But even the most advanced lithium battery still comes nowhere near the practical utility of a traditional jet engine.",
        "Throughout history, humans have used tools and machines to reduce the burden of physical labour. We are entering a new era with robots smart enough to act independently in complex and dynamic environments. But smart machines with dumb bodies will only get us so far.",
        "How are new and emerging geospatial technologies supporting market growth and wider economic, social and environmental value?"
    ]

    function pageBodyLoad() {
        // get filters
        this.instantSearch = new InstantSearch(document.getElementById("instantSearchResultsHolder"), new AllFilters("instantSearch"));
        checkUserStatus();
    }

    function checkUserStatus() {
        let method, url, input;

        method = "GET";
        url = "../api/user/user_actions.php?action=check_user";

        const checkUserStatusSuccess = function (response) {
            getUserStatusLoad(JSON.parse(response));
        }

        const checkUserStatusError = function () {
            var response = {
                "logged_in": false,
                "message": "Could not check user status"
            }
            getUserStatusLoad(response);
        }

        coreFunctions.xhrHelper(method, url, checkUserStatusSuccess, checkUserStatusError, input);
    }

    function getUserStatusLoad(response) {
        if (response.logged_in == true) {
            coreFunctions.userguidingSetup(response);
            searchPage.instantSearch.filters.getAllFilters(getFiltersOnLoad);
        } else {
            requireLogin();
        }
    }

    function getFiltersOnLoad() {
        searchPage.instantSearch.filters.saveFiltersState(searchPage.instantSearch.filters.getFiltersForSearch()); // Save initial state of filters
        showPageContent();

    }

    function showPageContent() {
        document.getElementById("main").classList.remove("hidden");
    }

    function copyExampleSearch(element) {
        const searchIndex = parseInt(element.dataset.example_index);
        document.getElementById("instantSearchForm").elements.text.value = instantSearchExamples[searchIndex];
    }

    return {
        instantSearch: instantSearch,
        copyExampleSearch: copyExampleSearch,
        pageBodyLoad: pageBodyLoad
    }
}();
